import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./Progress.css";
// import Gantt from "../Gantt/gantt";
// import Dashboard from "../dashboard/dashboard";
import _ from 'lodash';
import Activities from "../../components/Activity/Activity";
import ProjectTasks from '../../components/ProjectTasks/ProjectTasks';
import MilestonesNew from "../Milestone/MilestonesNew";
import DealDashboardTimesheet from "../../components/Activity/DealDashboardTimesheet";
const Progress = (props) => {
  const [key, setKey] = useState("dashboard");
  const [tasksForDeal, setTasksForDeal] = useState([]);
  const [DealsId, setDealsId] = useState("");
  const [dealName, setDealName] = useState({})
  useEffect(() => {
    if (props.dealObj.Project_ID) {
      setDealsId(props.dealObj.Project_ID);
      setDealName(props.dealObj?.Deal_Name)
    }
  }, [props.dealObj]);
  console.log("dealobj",props.dealObj);
  
  // const getDealObj=(clone)=>{
  //     let dealObj=_.cloneDeep(clone);
  //     delete dealObj.zoningList;
  //     delete dealObj.commercialList;
  //     delete dealObj.specialDistList;
  //     return dealObj
  // }
  return (
    <div>
      <Tabs
        style={key == 'milestones' ? { marginBottom: '12px' } : {}}
        id="progress-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="job-middle-tab job-middle-tabs progress-inner-tabs"
      >
        <Tab eventKey="dashboard" title="Dashboard">
          DashBoard
          {/* <Dashboard eventKey={key} dealsId={DealsId} /> */}
        </Tab>
        <Tab eventKey="tasks" title="Tasks">
          <ProjectTasks 
           checkType = {props.checkType}
           setCheckType = {props.setCheckType}
           dealListStatus = {props.dealListStatus}
           dealListTriggers = {props.dealListTriggers}
           getParams = {props.getParams}
           location = {props.location}
           history =  {props.history}
           fromBody =  {true}
           dealObj = {props.dealObj}
           setTasksForDeal = {setTasksForDeal}
          />
          {/* <Tasks
          dealColor={props.dealColor}
          taskLayout={props.taskLayout}
          history={props.history}
            allMilestones={props.allMilstones}
            getAllMilestone={props.getAllMilestone}
            isView={props.isView} isAccess={props.isAccess} selectedRole={props.selectedRole} deals={props.allDeals} eventKey={key} searchTask={props.searchTask} id='task' dealObj={props.dealObj} dealsId={DealsId} /> */}

        </Tab>
        <Tab eventKey="gantt" title="Gantt & Reports">
          Gantt Reports
          {/* <Gantt eventKey={key} dealsId={DealsId} /> */}

        </Tab>
        {/* <Tab eventKey="tasks" title="Tasks">
              <Tasks jobNo={props.job.ProjectNumber}/>
              </Tab> */}
        <Tab eventKey="milestones" title="Milestones">
          {/* Milestone */}
          {/* <Milestone allMilstones={props.allMilstones} dealObj={props.dealObj} eventKey={key} projectId={DealsId} /> */}
          <MilestonesNew dealName={props.dealObj?.Deal_Name}/>
        </Tab>
        <Tab eventKey="timesheet" title="Timesheet">
          <DealDashboardTimesheet tasksForDeal={tasksForDeal}/>
        </Tab>
        <Tab eventKey="issues" title="Issues">
          Issues
        </Tab>
        <Tab eventKey="activity" title="Activities">
          <Activities data={props.jobData} tasksForDeal={tasksForDeal} propObj={props.dealObj} dealNames={dealName}/>
        </Tab>
      </Tabs>
    </div>
  );
};

export default Progress;
